import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./forget-password.css";
import Footer from "../footer/footer.js";
import { Link } from "react-router-dom";
import axios from "axios";
import { handleError, handleSuccess } from "../../utils.js";
import logo from "../../assets/wjcw_logo.png";
import http from "../../core/service/http.js";
import Header from "../header/header.js";
import { useForgetPasswordHook } from "./useForgetPasswordHook.js";

const ForgetPassword = () => {
  const { validationSchema, handleSubmit } = useForgetPasswordHook();

  return (
    <>
      <Header />
      <div className="main-container">
        <div className="container-adjust h-100">
          <div className="row h-100">
            {/* Left Section */}
            <div className="col-md-6 d-flex flex-column align-items-center justify-content-center text-white">
              <div className="left-font">
                <h1>Admin Login</h1>
                <ul>
                  <li>World First Welfare 2x2 via technology</li>
                  <li>Benefit for everyone around the globe</li>
                  <li>Help each other in good deeds</li>
                  <li>We hope for a long and successful journey with you</li>
                  <li>Established in 2020</li>
                </ul>
              </div>
            </div>
            <div className="vertical-line col-md-1"></div>
            {/* Right Section */}
            <div className="col-md-5 d-flex align-items-center justify-content-center bg-white">
              <div className="w-75">
                <h2 className="text-center">Welcome</h2>
                <p className="text-center text-muted">
                  Please Enter Your Email
                </p>
                <Formik
                  initialValues={{ email: "" }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting, errors, touched }) => (
                    <Form>
                      <div className="mb-3">
                        <Field
                          type="email"
                          name="email"
                          className={`form-control ${
                            errors.email && touched.email ? "field-error" : ""
                          }`}
                          placeholder="Email"
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                      <button
                        type="submit"
                        className="btn btn-green w-100 mb-3 text-white"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </Form>
                  )}
                </Formik>
                <div className="text-center">
                  Already have an account?{" "}
                  <Link to="/" className="text-muted">
                    login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ForgetPassword;
